import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLines, Reveal } from "../Reveal";
import { scrollToId } from "../Navbar";

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const yWord = useTransform(scrollYProgress, [0, 1], ["0%", "-20%"]);
  const opacityWord = useTransform(scrollYProgress, [0, 0.8], [0.09, 0]);

  return (
    <section
      ref={ref}
      id="hero"
      data-testid="hero-section"
      className="relative flex min-h-[100vh] w-full items-end overflow-hidden pb-20 pt-32 md:pt-40"
    >
      {/* Decorative giant italic word */}
      <motion.p
        style={{ y: yWord, opacity: opacityWord }}
        className="pointer-events-none absolute -bottom-8 -right-6 select-none whitespace-nowrap font-display text-[38vw] italic leading-none tracking-tighter text-[#16181a] md:-bottom-16 md:-right-10 md:text-[26vw]"
        aria-hidden="true"
      >
        creatività
      </motion.p>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 md:px-14">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 flex items-baseline gap-6 md:col-span-12">
            <span className="overline">Direttore Creativo</span>
            <span className="hidden text-xs uppercase tracking-[0.28em] text-[#6e6a64] md:inline">
              — Personal Brand
            </span>
          </div>

          <h1 className="col-span-12 mt-4 font-display font-light leading-[0.95] tracking-tight text-[#16181a]">
            <MaskedLines
              lines={["Gianni Ragone"]}
              lineClass="text-[13vw] md:text-[9.5vw]"
              delay={0.15}
            />
          </h1>

          <div className="col-span-12 mt-12 md:col-span-9 md:mt-24">
            <Reveal delay={0.35}>
              <p className="font-display text-3xl font-light leading-[1.08] tracking-tight text-[#16181a] md:text-[5.4vw]">
                Grafica, video e social media.{" "}
                <span className="italic text-[#c0442b]">Una visione creativa d'insieme.</span>
              </p>
            </Reveal>
          </div>

          <div className="col-span-12 mt-10 flex flex-col items-start justify-between gap-8 md:mt-14 md:flex-row md:items-end">
            <Reveal delay={0.5}>
              <p className="max-w-xl font-body text-base leading-relaxed text-[#2a2b2d] md:text-lg">
                Sono Gianni Ragone, Direttore Creativo esperto in grafica pubblicitaria,
                produzioni video e social media marketing. Il mio lavoro mette in relazione
                linguaggio visivo, contenuti e comunicazione.
              </p>
            </Reveal>

            <Reveal delay={0.6}>
              <div className="flex flex-wrap items-center gap-4">
                <button
                  data-testid="hero-cta-primary"
                  onClick={() => scrollToId("contatti")}
                  className="group inline-flex items-center gap-3 bg-[#16181a] px-7 py-4 font-body text-sm font-semibold uppercase tracking-widest text-[#f0ead9] transition-colors duration-300 hover:bg-[#c0442b]"
                >
                  Parliamo del tuo progetto
                  <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
                </button>
                <button
                  data-testid="hero-cta-secondary"
                  onClick={() => scrollToId("approccio")}
                  className="group inline-flex items-center gap-3 border-b border-[#16181a] pb-2 font-body text-sm font-semibold uppercase tracking-widest text-[#16181a] transition-colors duration-300 hover:text-[#c0442b]"
                >
                  Scopri il mio approccio
                  <span className="transition-transform duration-300 group-hover:translate-x-1">↓</span>
                </button>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
